import React from 'react'
import { Checkbox } from 'semantic-ui-react';
import PropTypes from "prop-types";

const CheckboxToggle = ({ onChange, ...rest }) => {
    const onCheckboxChange = (e, data) => {
        if(onChange){
        onChange(data.checked)
        }
    }   
    return <Checkbox toggle onChange={onCheckboxChange} {...rest} />
}
CheckboxToggle.propTypes = {    
    onChange: PropTypes.func
}

export default CheckboxToggle;